module.exports = __webpack_public_path__ + "static/media/Group.19d9147c.svg";